"use strict";

var moment = require('moment');

module.exports = function (accumulator, order, product, component) {
  var todayFormatted = moment().format('M/D');
  var note = '';

  if (component.updated_files) {
    note += "\n**Please use file from ".concat(todayFormatted, " with \"UPDATED\" in the name**");
  }

  if (order.reprint_reason === 'EXTRA_ITEMS') {
    note += '\n**Extras only, no changes made**';
  }

  if (order.reprint_reason === 'SHIPMENT_LOST_OR_DAMAGED') {
    note += '\n**Shipment lost/damaged in transit, full reprint needed**';
  }

  if (order.reprint_reason === 'PRE_PRESS_ISSUES_ORIGINAL' || order.reprint_reason === 'PRINTING_ISSUES_PRODUCTION_ORIGINAL') {
    note += '\n**Use files from XX/XX date.**';
  }

  if (order.reprint_reason === 'MISSING_PIECES_PRINTER_COUNT_MATCHES') {
    note += '\n**Compare to previous order, color must match.**';
  }

  if (order.match_color) {
    note += '\n**Color must match previous order. Print one test sheet of items in color before running full job.**';
  }

  return accumulator + note;
};